<template>
  <div :style="{ '--color-fondo': ColorDeFondo }">
    <div class="swiper-custom">
      <div class="fondo-negro"></div>
      <!-- Botón de navegación izquierda -->
      <div class="swiper-button-prev"></div>
      <!-- Swiper -->
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div v-for="cat in categorias" :key="cat.id" class="swiper-slide">
            <p>{{ cat.name }}</p>
          </div>
        </div>
        <!-- Paginación -->
        <div class="swiper-pagination"></div>
      </div>
      <!-- Botones de navegación derecha -->
      <div class="swiper-button-next"></div>
    </div>
    <div class="contenedor-nombre">
      <span
        v-show="categoriaCentral && categoriaCentral.id != 0"
        class="font-weight-light font-italic nombre-centro"
      >
        {{ NombreCategoria }}
      </span>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
// import Swiper JS
// import Swiper from "swiper";
import Swiper from "swiper/bundle";
// import Swiper styles
import "swiper/swiper-bundle.css";

// core version + navigation, pagination modules:
// import SwiperCore, { Navigation, Pagination } from "swiper/core";

// // // configure Swiper to use modules
// SwiperCore.use([Navigation, Pagination]);

export default {
  name: "CarouselCategorias",
  data() {
    return {
      swiper: null,
      categoriaCentral: null,
    };
  },
  computed: {
    /** Color de la categoría actual o color por defecto */
    ColorDeFondo() {
      if (this.categoria) return this.categoria.color;
      else return "var(--color-moda-a)";
    },
    /** Nombre de la categoria central */
    NombreCategoria() {
      if (this.categoriaCentral) return this.categoriaCentral.name;
      else return "";
    },
    // Computed properties de vuex
    // Datos compartidos en toda la app
    ...mapState({
      categoria: (state) => state.categoria,
      categorias: (state) => state.categorias,
    }),
  },
  watch: {
    categoria(nueva, vieja) {
      if (nueva === vieja) return;

      if (this.swiper) {
        this.deslizarACategoria(nueva);
      }
    },
  },
  methods: {
    categoriaSeleccionada(cat) {
      this.$store.commit("cambiarCategoria", cat);
    },
    centroCambiado() {
      if (this.swiper)
        this.categoriaCentral = this.categorias[this.swiper.activeIndex];
    },
    deslizarACategoria(categoria) {
      const indice = this.categorias.indexOf(categoria);

      this.swiper.slideTo(indice);
    },
    finDeTransicion() {
      if (this.swiper) {
        const categoria = this.categorias[this.swiper.activeIndex];

        if (categoria != this.categoria) this.categoriaSeleccionada(categoria);
      }
    },
  },
  mounted() {
    this.swiper = new Swiper(".swiper-container", {
      // Esta opción es necesaria ya que sino se rompe (un bug de SwiperJS)
      centeredSlides: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      observer: true,
      on: {
        transitionEnd: () => this.finDeTransicion(),
        slideChange: () => this.centroCambiado(),
      },
      pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true,
      },
      slidesPerView: "auto",
      slideToClickedSlide: true,
    });

    if (this.categoria) this.deslizarACategoria(this.categoria);
  },
};
</script>
<style scoped>
.swiper-custom {
  display: flex;
  align-content: center;
}

.swiper-custom .fondo-negro {
  position: absolute;
  background-color: var(--color-estructura-a);
  width: 100%;
  height: 75px;
}

.swiper-button-prev,
.swiper-button-next {
  position: unset;
  margin: 0;
  padding-left: 20px;
  padding-right: 20px;
  height: 75px;
  --swiper-navigation-size: 15px;
  font-weight: bold;

  background-color: var(--color-estructura-a);
  color: #baece9;
}
.swiper-button-prev:hover,
.swiper-button-next:hover {
  --swiper-navigation-size: 20px;
  color: var(--color-estructura-c);
}

.swiper-container {
  height: 120px;
}

.swiper-wrapper {
}

.swiper-slide {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -ms-box-sizing: border-box;
  box-sizing: border-box;

  border-left: 1px solid #baece9;
  border-right: 1px solid #baece9;

  background-color: var(--color-estructura-a);
  color: #ebf9fd;
  width: 100px;
  height: 75px;
  display: flex;
  align-items: center;
  justify-content: center;
  word-break: break-word;
  cursor: pointer;
}

.swiper-slide p {
  margin: 0;
}

.swiper-slide-active {
  border-bottom: 5px solid #baece9;
  color: white;
}

.swiper-slide:hover:not(.swiper-slide-active) {
  color: var(--color-estructura-c);
}

.swiper-slide-active p {
}

.swiper-pagination >>> .swiper-pagination-bullet {
  background-color: var(--color-estructura-a);
  opacity: 1;
}
.swiper-pagination >>> .swiper-pagination-bullet-active {
  background-color: #baece9;
  opacity: 1;
}

.contenedor-nombre {
  background-color: var(--color-fondo);
}

.nombre-centro {
  font-size: 20px;
  overflow-wrap: unset;
  text-align: center;
  background-color: var(--color-estructura-a);
  color: white;
  padding: 5px 15px 5px 15px;
  margin: auto;
}
</style>
